import React, { useState } from 'react';
import DecisionTree from '@/components/DecisionTree';
import AdminView from '@/components/AdminView';

const Index = () => {
  const [showAdmin, setShowAdmin] = useState(false);

  return (
    <div>
      {showAdmin ? (
        <AdminView onBack={() => setShowAdmin(false)} />
      ) : (
        <DecisionTree onShowAdmin={() => setShowAdmin(true)} />
      )}
    </div>
  );
};

export default Index;
